const setAppFavicon = (iconHref: string) => {
  if (!iconHref) return;
  const iconElement = document.querySelector('link[type="image/svg+xml"]') as HTMLLinkElement;
  if (!iconElement) return;
  iconElement.href = iconHref;
};

export default setAppFavicon;
